import { FOREST_WORLD_HEIGHT, FOREST_WORLD_WIDTH } from "./assets";

/** Exactly matches the static image's object-fit: cover; object-position: center. */
export function getForestCoverLayout(viewportWidth: number, viewportHeight: number) {
  const safeWidth = Math.max(1, Number.isFinite(viewportWidth) ? viewportWidth : 1);
  const safeHeight = Math.max(1, Number.isFinite(viewportHeight) ? viewportHeight : 1);
  const scale = Math.max(safeWidth / FOREST_WORLD_WIDTH, safeHeight / FOREST_WORLD_HEIGHT);
  const width = FOREST_WORLD_WIDTH * scale;
  const height = FOREST_WORLD_HEIGHT * scale;
  return { scale, x: (safeWidth - width) / 2, y: (safeHeight - height) / 2, width, height };
}
